let _chromiumMajorVersionInUserAgent = null,
  _speculationRulesType,
  _allowQueryString,
  _allowExternalLinks,
  _useWhitelist,
  _delayOnHover = 65,
  _lastTouchstartEvent,
  _mouseoverTimer,
  _preloadedList = new Set();

init();

function init() {
  const supportChecksRelList = document.createElement('link').relList;

  const supportsPrefetch = supportChecksRelList.supports('prefetch');
  if (!supportsPrefetch) {
    return;
  }

  const chromium100Check = 'throwIfAborted' in AbortSignal.prototype;
  const firefox115AndSafari17_0Check = supportChecksRelList.supports('modulepreload');
  const safari15_4AndFirefox116Check = Intl.PluralRules && 'selectRange' in Intl.PluralRules.prototype;
  const firefox115AndSafari15_4Check = firefox115AndSafari17_0Check || safari15_4AndFirefox116Check;
  const isBrowserSupported = chromium100Check && firefox115AndSafari15_4Check;
  if (!isBrowserSupported) {
    return;
  }

  const handleVaryAcceptHeader = 'instantVaryAccept' in document.body.dataset || 'Shopify' in window;

  const chromiumUserAgentIndex = navigator.userAgent.indexOf('Chrome/');
  if (chromiumUserAgentIndex > -1) {
    _chromiumMajorVersionInUserAgent = parseInt(
      navigator.userAgent.substring(chromiumUserAgentIndex + 'Chrome/'.length),
    );
  }

  if (handleVaryAcceptHeader && _chromiumMajorVersionInUserAgent && _chromiumMajorVersionInUserAgent < 110) {
    return;
  }

  _speculationRulesType = 'none';
  if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
    const speculationRulesConfig = document.body.dataset.instantSpecrules;
    if (speculationRulesConfig == 'prerender') {
      _speculationRulesType = 'prerender';
    } else if (speculationRulesConfig != 'no') {
      _speculationRulesType = 'prefetch';
    }
  }

  const useMousedownShortcut = 'instantMousedownShortcut' in document.body.dataset;
  _allowQueryString = 'instantAllowQueryString' in document.body.dataset;
  _allowExternalLinks = 'instantAllowExternalLinks' in document.body.dataset;
  _useWhitelist = 'instantWhitelist' in document.body.dataset;

  let preloadOnMousedown = false;
  let preloadOnlyOnMousedown = false;
  let preloadWhenVisible = false;
  if ('instantIntensity' in document.body.dataset) {
    const intensityParameter = document.body.dataset.instantIntensity;

    if (intensityParameter == 'mousedown' && !useMousedownShortcut) {
      preloadOnMousedown = true;
    }

    if (intensityParameter == 'mousedown-only' && !useMousedownShortcut) {
      preloadOnMousedown = true;
      preloadOnlyOnMousedown = true;
    }

    if (intensityParameter == 'viewport') {
      const isOnSmallScreen = document.documentElement.clientWidth * document.documentElement.clientHeight < 450000;

      const isNavigatorConnectionSaveDataEnabled = navigator.connection && navigator.connection.saveData;
      const isNavigatorConnectionLike2g =
        navigator.connection && navigator.connection.effectiveType && navigator.connection.effectiveType.includes('2g');
      const isNavigatorConnectionAdequate = !isNavigatorConnectionSaveDataEnabled && !isNavigatorConnectionLike2g;

      if (isOnSmallScreen && isNavigatorConnectionAdequate) {
        preloadWhenVisible = true;
      }
    }

    if (intensityParameter == 'viewport-all') {
      preloadWhenVisible = true;
    }

    const intensityAsInteger = parseInt(intensityParameter);
    if (!isNaN(intensityAsInteger)) {
      _delayOnHover = intensityAsInteger;
    }
  }

  const eventListenersOptions = {
    capture: true,
    passive: true,
  };

  if (preloadOnlyOnMousedown) {
    document.addEventListener('touchstart', touchstartEmptyListener, eventListenersOptions);
  } else {
    document.addEventListener('touchstart', touchstartListener, eventListenersOptions);
  }

  if (!preloadOnMousedown) {
    document.addEventListener('mouseover', mouseoverListener, eventListenersOptions);
  }

  if (preloadOnMousedown) {
    document.addEventListener('mousedown', mousedownListener, eventListenersOptions);
  }
  if (useMousedownShortcut) {
    document.addEventListener('mousedown', mousedownShortcutListener, eventListenersOptions);
  }

  if (preloadWhenVisible) {
    let requestIdleCallbackOrFallback = window.requestIdleCallback;

    if (!requestIdleCallbackOrFallback) {
      requestIdleCallbackOrFallback = (callback) => {
        callback();
      };
    }

    requestIdleCallbackOrFallback(
      function observeIntersection() {
        const intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const anchorElement = entry.target;
              intersectionObserver.unobserve(anchorElement);
              preload(anchorElement.href);
            }
          });
        });

        document.querySelectorAll('a').forEach((anchorElement) => {
          if (isPreloadable(anchorElement)) {
            intersectionObserver.observe(anchorElement);
          }
        });
      },
      {
        timeout: 1500,
      },
    );
  }
}

function touchstartListener(event) {
  _lastTouchstartEvent = event;

  const anchorElement = event.target.closest('a');

  if (!isPreloadable(anchorElement)) {
    return;
  }

  preload(anchorElement.href, 'high');
}

function touchstartEmptyListener(event) {
  _lastTouchstartEvent = event;
}

function mouseoverListener(event) {
  if (isEventLikelyTriggeredByTouch(event)) {
    return;
  }

  if (!('closest' in event.target)) {
    return;
  }
  const anchorElement = event.target.closest('a');

  if (!isPreloadable(anchorElement)) {
    return;
  }

  anchorElement.addEventListener('mouseout', mouseoutListener, { passive: true });

  _mouseoverTimer = setTimeout(() => {
    preload(anchorElement.href, 'high');
    _mouseoverTimer = null;
  }, _delayOnHover);
}

function mousedownListener(event) {
  if (isEventLikelyTriggeredByTouch(event)) {
    return;
  }

  const anchorElement = event.target.closest('a');

  if (!isPreloadable(anchorElement)) {
    return;
  }

  preload(anchorElement.href, 'high');
}

function mouseoutListener(event) {
  if (event.relatedTarget && event.target.closest('a') == event.relatedTarget.closest('a')) {
    return;
  }

  if (_mouseoverTimer) {
    clearTimeout(_mouseoverTimer);
    _mouseoverTimer = null;
  }
}

function mousedownShortcutListener(event) {
  if (isEventLikelyTriggeredByTouch(event)) {
    return;
  }

  const anchorElement = event.target.closest('a');

  if (event.which > 1 || event.metaKey || event.ctrlKey) {
    return;
  }

  if (!anchorElement) {
    return;
  }

  anchorElement.addEventListener(
    'click',
    function (event) {
      if (event.detail == 1337) {
        return;
      }

      event.preventDefault();
    },
    { capture: true, passive: false, once: true },
  );

  const customEvent = new MouseEvent('click', { view: window, bubbles: true, cancelable: false, detail: 1337 });
  anchorElement.dispatchEvent(customEvent);
}

function isEventLikelyTriggeredByTouch(event) {
  if (!_lastTouchstartEvent || !event) {
    return false;
  }

  if (event.target != _lastTouchstartEvent.target) {
    return false;
  }

  const now = event.timeStamp;

  const durationBetweenLastTouchstartAndNow = now - _lastTouchstartEvent.timeStamp;

  const MAX_DURATION_TO_BE_CONSIDERED_TRIGGERED_BY_TOUCHSTART = 2500;

  return durationBetweenLastTouchstartAndNow < MAX_DURATION_TO_BE_CONSIDERED_TRIGGERED_BY_TOUCHSTART;
}

function isPreloadable(anchorElement) {
  if (!anchorElement || !anchorElement.href) {
    return;
  }

  if (_useWhitelist && !('instant' in anchorElement.dataset)) {
    return;
  }

  if (anchorElement.origin != location.origin) {
    let allowed = _allowExternalLinks || 'instant' in anchorElement.dataset;
    if (!allowed || !_chromiumMajorVersionInUserAgent) {
      return;
    }
  }

  if (!['http:', 'https:'].includes(anchorElement.protocol)) {
    return;
  }

  if (anchorElement.protocol == 'http:' && location.protocol == 'https:') {
    return;
  }

  if (!_allowQueryString && anchorElement.search && !('instant' in anchorElement.dataset)) {
    return;
  }

  if (anchorElement.hash && anchorElement.pathname + anchorElement.search == location.pathname + location.search) {
    return;
  }

  if ('noInstant' in anchorElement.dataset) {
    return;
  }

  return true;
}

function preload(url, fetchPriority = 'auto') {
  if (_preloadedList.has(url)) {
    return;
  }

  if (_speculationRulesType != 'none') {
    preloadUsingSpeculationRules(url);
  } else {
    preloadUsingLinkElement(url, fetchPriority);
  }

  _preloadedList.add(url);
}

function preloadUsingSpeculationRules(url) {
  const scriptElement = document.createElement('script');
  scriptElement.type = 'speculationrules';

  scriptElement.textContent = JSON.stringify({
    [_speculationRulesType]: [
      {
        source: 'list',
        urls: [url],
      },
    ],
  });

  document.head.appendChild(scriptElement);
}

function preloadUsingLinkElement(url, fetchPriority = 'auto') {
  const linkElement = document.createElement('link');
  linkElement.rel = 'prefetch';
  linkElement.href = url;

  linkElement.fetchPriority = fetchPriority;

  linkElement.as = 'document';

  document.head.appendChild(linkElement);
}
